module.exports = __webpack_public_path__ + "static/media/05.72df3244.png";